<template>
    <div class="ResetPass">
        <v-alert class="ResetPass_error" v-if="password !== confirm_password" :type="typeAlert" :icon="false" :dismissible="false" dense>Please check your password matches password confirmation.</v-alert>

        <form @submit.prevent="resetPasword">
            <h2 class="ResetPass_title text-h5 mb-5">Reset Password</h2>
            <div class="ResetPass_field">
                <label>New Password</label>
                <input v-model="password" placeholder="New Password" type="password">
                <password v-model="password" :strength-meter-only="true"/>
            </div>
            <div class="ResetPass_field">
                <label>Confirm New Password</label>
                <input v-model="confirm_password" placeholder="Confirm New Password" type="password">
            </div>
            <div>
                <v-btn color="primary" type="submit" link>Change Password</v-btn>
            </div>
        </form>
        <v-alert v-if="showError" :icon="false" dense class="mt-5" id="error" type="error">{{ messageAlert }}</v-alert>
    </div>
</template>

<script>
    import { mapGetters,mapActions } from "vuex";
    import Password from 'vue-password-strength-meter'

    export default {
        name: 'ResetPassword',
        data() {
            return {
                password:null,
                confirm_password:null,
                showError:false,
                messageAlert:"-----Errr0r------",
                typeAlert:'error'
            }
        },
        computed: { 
            ...mapGetters({ user:'StateUser'}) 
        },
        methods:{
            ...mapActions(["changePasswordFn"]),
            resetPasword(){
                const userData = new FormData();
                userData.append("username", this.user.username);
                userData.append("password", this.password===null ? '' : this.password);
                userData.append("confirm_password", this.confirm_password === null? '' : this.confirm_password );
                this.changeUserPassword(userData);
            },
            async changeUserPassword(userData){
                try {
                  const response =  await this.changePasswordFn(userData);
                  if(response.data.data.msg==='Error'){
                    console.log('Data------>');
                    this.validateForm(response.data.data.errors);
                  }else{
                    
                    this.user.isLogin = true; 
                    this.$store.commit( 'setUser', this.user);
                    this.$router.go(0);
                  }
                } catch (error) {
                    console.error('Error',error);
                }
            },
            validateForm(errors){
                let result  = false;
                console.log('Erros',errors)
                return result;
            }
        },
        components: { Password }
    }
</script>

<style lang="scss" scoped>
    @import '~@/scss/colors.scss';
    .ResetPass{
        &_error{
            font-size: 12px;
            text-align: center;
        }
        &_title{
            color: $purple;
        }
        &_field{
            display: block;
            margin-bottom: 20px;
            position: relative;
            label{
                width: 0;
                height: 0;
                visibility: hidden;
                position: absolute;
                opacity: 0;
            }
            input{
                background: #FFFFFF;
                font-size: 14px;
                display: block;
                width: 100%;
                height: 35px;
                padding: 0 20px;
                border: 1px solid #BFBFBF;
                border-radius: 4px;
                &::placeholder{
                color: #BFBFBF;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Login/ResetPassword.vue